<h2 mat-dialog-title>
  {{ 'epd.functions.careplan-nnn.results-section.info-dialog.title' | translate | capitalize }}
</h2>
<mat-dialog-content class="results-info">
  <ol class="results-info__sections">
    @for (section of sections; track section) {
      <li class="results-info__section">
        <h3 class="results-info__title">
          {{ 'epd.functions.careplan-nnn.results-section.info-dialog.' + section + '.title' | translate | capitalize }}
        </h3>
        <p class="results-info__line">
          <span class="results-info__question">
            {{ 'epd.functions.careplan-nnn.results-section.info-dialog.what-label' | translate | capitalize }}
          </span>
          {{ 'epd.functions.careplan-nnn.results-section.info-dialog.' + section + '.what' | translate | capitalize }}
        </p>
        <p class="results-info__line">
          <span class="results-info__question">
            {{ 'epd.functions.careplan-nnn.results-section.info-dialog.why-label' | translate | capitalize }}
          </span>
          {{ 'epd.functions.careplan-nnn.results-section.info-dialog.' + section + '.why' | translate | capitalize }}
        </p>
      </li>
    }
  </ol>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" mat-dialog-close>
    {{ 'general.actions.close' | translate | capitalize }}
  </button>
</mat-dialog-actions>
